import React from "react";
import { useSelector } from "react-redux";
import "./portal.css";
import Trainee from "./user";
import Operations from "./operations";
import Clock from "./clock";
// import { Button, Popconfirm } from "antd"; // Uncomment if End Test is enabled
// import Alert from "../../common/alert";
// import apis from "../../../services/Apis";
// import { Post } from "../../../services/axiosCall";

const Sidepanel = ({ mode }) => {
  const trainee = useSelector((state) => state.trainee);

  return (
    <div
      className={
        "side-panel-in-exam-dashboard " +
        (mode === "desktop" ? "w-20" : "w-100")
      }
    >
      <Trainee />
      <Clock />
      <Operations />

      {/* Uncomment below to re-enable End Test UI
      <div className="End-test-container">
        <Popconfirm
          title="Are you sure to end the test?"
          onConfirm={handleEndTest}
          okText="Yes"
          cancelText="No"
        >
          <Button type="default">End Test</Button>
        </Popconfirm>
      </div>
      */}
    </div>
  );
};

export default Sidepanel;
